<div class="page-container">
    <img class="page-img" src="../../../assets/images/bas-logo-light.svg">
    <h2>Server Maintenance</h2>
    <p>Oops! looks like something went wrong.</p>
    <p>We are working on it.</p>
    <button class="after-sometime">TRY AFTER SOMETIME</button>
    <img class="server-maintainance" src="../../../assets/images/server-maintainance-icon.svg">
</div>